import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "videos-grid" }
const _hoisted_2 = { class: "videos grid" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "row file-icon" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = { class: "row file-name" }
const _hoisted_7 = { class: "row analytics between" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "row analytics between" }
const _hoisted_10 = {
  key: 0,
  class: "value"
}
const _hoisted_11 = {
  key: 1,
  class: "value"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "add-icon" }
const _hoisted_14 = { class: "add-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Boolean = _resolveComponent("Boolean")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video) => {
        return (_openBlock(), _createElementBlock("div", {
          key: video.id,
          class: "col sm:col-6 xl:col-3"
        }, [
          (_ctx.preparedVideos[`video-${video.videoReference}`])
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "video",
                onClick: ($event: any) => (_ctx.viewVideo(video.videoReference, video.textItems, video.id))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "video",
                      size: "3x"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.findTextItem("title", video.textItems)), 1),
                _createElementVNode("div", _hoisted_7, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "key" }, "Viewed", -1)),
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_Boolean, {
                      value: 
                  !!(
                    video.actionProgressObjects[0].viewed ||
                    video.actionProgressObjects[0].completed
                  )
                
                    }, null, 8, ["value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "key" }, "Signed", -1)),
                  (_ctx.getSignOffStatus(video.videoReference))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createVNode(_component_Boolean, {
                          value: 
                  !!(
                    video.actionProgressObjects[0].viewed &&
                    video.actionProgressObjects[0].completed
                  )
                
                        }, null, 8, ["value"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, "N/A"))
                ])
              ], 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "not-uploaded video",
                onClick: ($event: any) => (_ctx.viewVideo(video.videoReference, video.textItems, video.id))
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "icon",
                    size: "3x",
                    icon: "plus"
                  })
                ]),
                _createElementVNode("span", _hoisted_14, " Click to add " + _toDisplayString(_ctx.findTextItem("title", video.textItems)) + " here ", 1)
              ], 8, _hoisted_12))
        ]))
      }), 128))
    ])
  ]))
}